import { useMemo } from "react";
import DrinksMenuPanel from "./DrinksMenuPanel";
import { getAlcoholBoardPanels } from "../../../data/drinksMenuLayout";

function DrinksMenuAlcoholBoard({ lang, onOpen }) {
  const panels = useMemo(() => getAlcoholBoardPanels(lang), [lang]);

  return (
    <div className="drinks-menu-board drinks-menu-board--alcohol">
      <div className="drinks-menu-alcohol-grid" role="list">
        {panels.map((panel) => (
          <DrinksMenuPanel
            key={panel.id}
            panel={panel}
            lang={lang}
            onOpen={onOpen}
          />
        ))}
      </div>
    </div>
  );
}

export default DrinksMenuAlcoholBoard;
